// Tiny eager bridge: the Help menu (DashboardNav) starts the lazily-mounted tour
// without importing anything from the tour chunk.
type Listener = () => void;
const listeners = new Set<Listener>();

export function requestTourStart(): void {
  listeners.forEach((fn) => fn());
}

export function onTourStartRequest(fn: Listener): () => void {
  listeners.add(fn);
  return () => listeners.delete(fn);
}
